import { render, staticRenderFns } from "./InspectVue.vue?vue&type=template&id=bb7bbf6e&"
import script from "./InspectVue.vue?vue&type=script&lang=js&"
export * from "./InspectVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports